import { TablePagination } from '../../TablePagination'

function TableModalPagination({ pagination, ...restProps }) {
  return <TablePagination {...restProps} value={pagination} />
}

export default TableModalPagination
